import { render, staticRenderFns } from "./AdministratorHome.vue?vue&type=template&id=2cf3dc44&"
import script from "./AdministratorHome.vue?vue&type=script&lang=js&"
export * from "./AdministratorHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports